import baseService, { Service } from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const loginService = (credentials) => {
    return Service.post('/driver-auth/login', credentials, {
        params: getModelTypeIDAndEntityID(),
    });
};

export const ssoAuthService = (data) => {
    return Service.post(
        '/driver-auth/sso-auth',
        {},
        {
            params: { modelTypeID: data.modelTypeID, entityID: data.entityID },
            headers: {
                Authorization: `Bearer ${data.token}`,
            },
        }
    );
};

export const portalLoginService = (credentials) => {
    return Service.post('/driver-auth/portal-login', credentials);
};

export const submitInitialEmailService = (emailAddress) => {
    return Service.post('/driver-auth/initial-email-submit', {
        email: emailAddress,
        ...getModelTypeIDAndEntityID(),
    });
};

export const forgotPasswordService = (payload, scope) => {
    return Service.post('/driver-auth/forgot-password', payload, {
        // Prefer an explicitly-passed scope — e.g. the portal the driver selected on the login
        // screen before clicking "Forgot Password?", which is not yet persisted to localStorage.
        // Fall back to the stored scope for authenticated callers.
        params: scope || getModelTypeIDAndEntityID(),
    });
};

export const validateSetPasswordTokenService = (token) => {
    return Service.post('/driver-auth/validate-set-password-token', { token });
};

export const resetPasswordService = (payload) => {
    return Service.post('/driver-auth/reset-password', payload);
};

export const updatePasswordService = (data) => {
    return baseService.put('/driver-auth/update-password', data);
};

export const checkPassword = (data) => {
    return baseService.post('/driver-auth/check-password', { data });
};

export const loginImageService = () => {
    return Service.get('/auth/login-image');
};
